import type { ContentData, ContentType } from "@/api/content";
import { Markdown } from "@/components";
import { AttachmentList } from "./AttachmentList";
import { ChecklistView } from "./ChecklistView";
import { ContactCardView } from "./ContactCardView";
import { LinkView } from "./LinkView";
import { VideoView } from "./VideoView";
import { WorkflowView } from "./WorkflowView";

/**
 * Renders a module's content by type. Shared by the employee program view and the
 * authoring live preview, so both always show the same thing.
 */
export function ModuleContent({
  type,
  content,
  onChecklistToggle,
  readOnly,
}: {
  type: ContentType;
  content: ContentData;
  onChecklistToggle?: (index: number, checked: boolean) => void;
  readOnly?: boolean;
}) {
  switch (type) {
    case "document":
    case "rule":
      return (
        <>
          <Markdown>{content.markdown ?? ""}</Markdown>
          <AttachmentList attachments={content.attachments ?? []} />
        </>
      );
    case "workflow":
      return <WorkflowView content={content} />;
    case "checklist":
      return <ChecklistView content={content} onToggle={onChecklistToggle} readOnly={readOnly} />;
    case "contact_card":
      return <ContactCardView content={content} />;
    case "video":
      return <VideoView content={content} />;
    case "link":
      return <LinkView content={content} />;
  }
}
